import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const ConditionQuestsSkeleton: FC = () => {
  return (
    <Stack gap={1}>
      {[1, 2, 3].map(i => (
        <Stack key={i} direction="row" gap={0.5} alignItems="center" justifyContent="space-between">
          <ThemedSkeleton variant="text" colorVariant="secondary" width="70%" height={20} />
          <ThemedSkeleton variant="text" colorVariant="secondary" width="20%" height={20} />
        </Stack>
      ))}
    </Stack>
  );
};

